// @flow
import React from 'react';
import './styles.css';

export default function Disclaimer() {
  return (
    <footer className="Disclaimer">
      El presente cálculo es meramente indicativo. El mismo no implica oferta de crédito ni aceptación de la solicitud de crédito por parte de la Asociación Mutual 9 de Julio Olímpico de Freyre. El otorgamiento quedará, en todos los casos, sujeto al previo análisis y calificación crediticia del solicitante y a las condiciones de contratación de esta Entidad Financiera. La línea de préstamos comerciales (línea J) es exclusiva para clientes Agro.
    </footer>
  );
}
